<template>
  <div class="klant-logos">
      <ul>
          <li v-for="(logo, index) in logos" v-bind:key="index">
              <img :src="logo.logo.url">
          </li>
      </ul>
  </div>
</template>

<script>
import { settings } from '../variables.js'

export default {
  data () {
    return {
      logos: []
    }
  },
  created: function () {
    this.axios
      .get(settings.jsonUrl + 'acf/v3/options/options')
      .then(response => (this.logos = response.data.acf.klantlogos))
      .catch(error => console.log(error))
  },
  methods: {
    slug (str) {
      return str.toString().replace(settings.baseUrl, '').replace('/', '')
    }
  }
}
</script>

<style lang="scss">
.klant-logos {
    padding: 2em 1em;
    background-color: #949494;

    ul {
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        grid-gap: 2em;
        max-width: 1024px;
        margin: 0 auto;
        list-style: none;
        padding-left: 0;

        @media all and (min-width: 768px) {
            grid-template-columns: repeat(5, 1fr);
        }

        @media all and (min-width: 1024px) {
            grid-template-columns: repeat(7, 1fr);
        }
    }
}
</style>
